import React, { useCallback, useState } from 'react'

type AccordionProps = {
  renderLabel: (isOpened: boolean) => React.ReactNode
  onToggleHandler?: (isOpened: boolean) => void
  classes?: {
    opened?: string
    closed?: string
  }
}

const Accordion = ({ children, renderLabel, onToggleHandler, classes }: React.PropsWithChildren<AccordionProps>) => {
  const [isOpened, setIsOpened] = useState(false)

  const toggleIsOpened = useCallback(() => {
    setIsOpened(!isOpened)
    onToggleHandler?.(!isOpened)
  }, [setIsOpened, isOpened, onToggleHandler])

  return (
    <div className={isOpened ? classes?.opened : classes?.closed}>
      <div onClick={toggleIsOpened}>{renderLabel(isOpened)}</div>
      {isOpened ? children : null}
    </div>
  )
}

export default Accordion
